import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()(() => ({
  rootBox: {
    position: "relative",
    background:
      "radial-gradient(at 0% 0%, rgba(77, 18, 119, 0.05) 0, transparent 70%), radial-gradient(at 100% 0%, rgba(24, 119, 242, 0.05) 0, transparent 70%)",
    height: "calc(100vh - 120px)",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0.05)",
      borderRadius: "10px",
    },
  },
  decorationBlob: {
    position: "absolute",
    top: "-150px",
    right: "-100px",
    width: "500px",
    height: "500px",
    background:
      "radial-gradient(circle, rgba(37, 211, 102, 0.04) 0%, rgba(18, 140, 126, 0.02) 50%, transparent 100%)",
    borderRadius: "50%",
    filter: "blur(60px)",
    zIndex: 0,
    pointerEvents: "none",
  },
  stickyHeader: {
    position: "sticky",
    top: "0px",
    zIndex: 10,
    margin: "0 -30px",
    padding: "0 30px",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  headerTextStyle: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "14px",
    color: "#999",
    textTransform: "uppercase",
    letterSpacing: "1px",
    marginBottom: "20px",
    display: "block",
  },
  loadingCircularProgressBox: {
    height: "calc(100vh - 200px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default useStyle;
